import React, { useState } from "react";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getGameById } from "../api/game";
import flechaAvanzar from "../assets/right-arrow.svg";
import ScenarioBar from "../components/ScenarioBar";
import { useLang } from "../translations/i18n";
import { ROUTES } from "../utils/constants";
import { updateStats, updateTimer, getTimer, setLastTickNow } from "../utils/helpers";
import { modalWait } from "../utils/logger";
import oncommit from "../assets/hemmexus.png";
import avatarDirector from "../assets/bg/director-bg-sg5.png";

import { useVideoWithSound } from "../hooks/useVideoWithSound";

function GameIntroduction({ intl }) {
  const lang = useLang();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const game = useSelector((state) => state.game);
  const group = useSelector((state) => state.group);
  const [isCompleted, setIsCompleted] = useState(false);
  const [loading, setLoading] = useState(false);
  const { state } = useLocation();
  const { completed } = state || false;

  const { videoRef, canPlayWithSound } = useVideoWithSound({ 
	autoPlay: true, 
	volume: 0.8
  });

  const activeScenario = 0;

  const handleStartGame = (e, direction = "next") => {
    e.preventDefault();
    setLoading(true);
    getGameById(game?._id).then((res) => {
      if (res.status === 200) {
        navigate(ROUTES.SCENARIO1_INTRO, {
          state: { activeScenario: 1 },
        });
      } else {
      	setLoading(false);
	  }
    });
  };
	return (
			<div className="h-100">
				<div className="container-fluid position-relative h-100">
					<div className="row h-100 d-flex align-items-center">
						<div className="col-md-3 d-flex flex-column justify-content-between h-100 px-4 pb-4">
							<img
								className="mt-4"
								src={oncommit}
								alt="decorativo"
								style={{
									maxWidth: "70%",
								}}
							/>
						</div>
						<div className="col-md-9 d-flex flex-column justify-content-center h-100 pb-3 bg-blur" style={{paddingTop: "10px"}}>
							<div className="container-fluid position-relative h-100">
								<div className="row h-100 d-flex align-items-center">
									<div className="col-md-9">
										<div className="text-center">
											<img src={avatarDirector} alt="Director" className="w-50" />
										</div>
										<div className="recuadro-white mb-3 w-100 mt-0" style={{marginTop: "10px"}}>
											<p className="txtTexto2 black">
												<strong>¿Preparados?</strong> A continuación, se presentan los detalles del caso clínico que resolveremos hoy.
											</p>
										</div>
									</div>
									<div className="col-md-3 d-flex flex-column justify-content-end align-items-center h-100">
										<div className="d-flex justify-content-end align-items-center mb-4">
											<div className="txtBotones txt-white me-3">
												Siguiente
											</div>
											<button
												onClick={(e) => handleStartGame(e, "next")}
												className="btn-main btn-progress"
												data-loading={loading ? "true" : "false"}
												style={{ width: 60, height: 60, borderRadius: "50%" }}
												aria-busy={loading}
											>
												<img
												src={flechaAvanzar}
												alt="Siguiente"
												style={{ maxWidth: "40px" }}
												/>
											</button>              
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

export default injectIntl(GameIntroduction);
